import {initBOCookieBar} from "./cookieBar";
import {initIndexSiteDescription} from "./indexSiteDescription";


if(document.querySelector(".cookieBar")) {
  initBOCookieBar();
}

if(document.querySelector(".indexSiteDescription")) {
  initIndexSiteDescription();
}